import React from "react";
import { useIntl } from "react-intl";

import { svgIcon } from "../../utils/svgProvider";

const CloseButton = ({
	stringId = "komid.register.close.label",
	onClick,
	...props
}) => {
	const { formatMessage } = useIntl();
	return (
		<button
			className="close"
			onClick={onClick}
			{...props}
			title={formatMessage({ id: stringId })}
		>
			{svgIcon.close}
		</button>
	);
};

export default CloseButton;
